import {Box, Grid, InputBase, Typography} from "@mui/material";
import {controlSx, FieldLabel, FieldHelper} from "./formFieldShared";

const ScheduleInfo = () => (
  <Box sx={{p: 1.5, borderRadius: "12px", bgcolor: "rgba(132, 145, 247, 0.08)"}}>
    <Typography sx={{fontSize: 13, color: "#374151"}}>
      <strong>Schedule:</strong> every day from the <strong>start date</strong> to the <strong>end date</strong> (both
      included), the campaign calls its phone numbers, but only between the <strong>start time</strong> and
      the <strong>end time</strong>.
    </Typography>
    <Typography sx={{fontSize: 13, color: "#374151", mt: 0.5}}>
      <strong>Automatic calling:</strong> every 5 minutes, numbers that are due are queued and called. Each number is
      called <strong>at most once per day</strong>, so retries happen on the following days.
    </Typography>
    <Typography sx={{fontSize: 13, color: "#374151", mt: 0.5}}>
      <strong>Max attempts:</strong> the maximum number of calls to each phone number. A number keeps
      being called until it answers or the max attempts is reached.
    </Typography>
  </Box>
);

export const CampaignScheduleFieldsNew = ({form, errors, setField}) => {
  return (
    <>
      <Grid item xs={12}>
        <ScheduleInfo/>
      </Grid>
      <Grid item xs={6} md={3}>
        <FieldLabel required>Start date</FieldLabel>
        <Box sx={controlSx}>
          <InputBase fullWidth type="date" value={form.startDate} onChange={setField("startDate")} inputProps={{"aria-label": "Start date"}} sx={{flex: 1, fontSize: 13, color: "#23264D"}}/>
        </Box>
        <FieldHelper>First day of calling</FieldHelper>
      </Grid>
      <Grid item xs={6} md={3}>
        <FieldLabel required>End date</FieldLabel>
        <Box sx={{...controlSx, ...(errors.endDate && {boxShadow: "inset 0 0 0 1.5px #DC2626"})}}>
          <InputBase fullWidth type="date" inputProps={{min: form.startDate || undefined, "aria-label": "End date"}} value={form.endDate} onChange={setField("endDate")} sx={{flex: 1, fontSize: 13, color: "#23264D"}}/>
        </Box>
        <FieldHelper error={!!errors.endDate}>{errors.endDate || "Last day of calling"}</FieldHelper>
      </Grid>
      <Grid item xs={6} md={3}>
        <FieldLabel required>Start time</FieldLabel>
        <Box sx={controlSx}>
          <InputBase fullWidth type="time" value={form.startTime} onChange={setField("startTime")} inputProps={{"aria-label": "Start time"}} sx={{flex: 1, fontSize: 13, color: "#23264D"}}/>
        </Box>
        <FieldHelper>Daily calling starts</FieldHelper>
      </Grid>
      <Grid item xs={6} md={3}>
        <FieldLabel required>End time</FieldLabel>
        <Box sx={{...controlSx, ...(errors.endTime && {boxShadow: "inset 0 0 0 1.5px #DC2626"})}}>
          <InputBase fullWidth type="time" value={form.endTime} onChange={setField("endTime")} inputProps={{"aria-label": "End time"}} sx={{flex: 1, fontSize: 13, color: "#23264D"}}/>
        </Box>
        <FieldHelper error={!!errors.endTime}>{errors.endTime || "Daily calling stops"}</FieldHelper>
      </Grid>
    </>
  )
}
